<mat-card class="cont">
  <mat-card-content>
    <p>
      {{ message.twilio.body }}
    </p>
    <button mat-button color="accent" *ngIf="camera" (click)="viewCamera = !viewCamera">
      <ng-container *ngIf="!viewCamera; else cameraOpen">
        <sn-icon>play_arrow</sn-icon>
        &nbsp;{{ 'communication.chat.viewCamera' | t }}
      </ng-container>
      <ng-template #cameraOpen>
        <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
        &nbsp;{{ 'communication.chat.hideCamera' | t }}
      </ng-template>
    </button>
    <sn-audit-camera-stream-view
      *ngIf="viewCamera"
      class="share-camera"
      [autoplay]="true"
      [camera]="camera"
      [controls]="true"
    >
    </sn-audit-camera-stream-view>
  </mat-card-content>
</mat-card>
